module.exports = __webpack_public_path__ + "static/media/2.92a1122f.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/moan/2.mp3
// module id = 478
// module chunks = 0